import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { constescapeCSVField, ResponseMessageTypes, SnackbarService } from '@app/shared';

@Component({
    selector: 'app-stock-order-view-modal',
    templateUrl: './stock-order-view-modal.component.html',
    styles: [`.fixed-height {height: 40px} 
        .print-comment-field {display: none} 
        .show-comment-field {display: block}
        @media print {
            .print-comment-field {
                display: block
            }
            .show-comment-field {
                display: none
            }
        }`
    ]
})

export class StockOrderViewModalComponent implements OnInit {

    exportListDetails: any;
    dateFormat = 'MMM dd, yyyy';

    constructor(
        @Inject(MAT_DIALOG_DATA) public stockOrderModalData,
        private snackbarService: SnackbarService, private datePipe: DatePipe,
    ) {
        this.exportListDetails = stockOrderModalData.stockOrderModalDetails;

    }

    ngOnInit(): void {
    }

    exportList() {
        if (this.exportListDetails.length != 0) {
            let fileName = 'Audit Info Details' + this.datePipe.transform((new Date()), this.dateFormat) + '.csv';
            let columnNames = ["Stock Code", "Created Date and Time", "Action", "Field Name", "Current Comment", "Previous Comment", "User Name"];
            let header = columnNames.join(',');
            let csv = header;
            csv += '\r\n';
            this.exportListDetails.map(c => {
                csv += [c['stockCode'], this.datePipe.transform(c['createdDate'], 'date'), c['actions'], c['fieldName'], `"${constescapeCSVField(c?.currentComment)}"`, `"${constescapeCSVField(c?.previousComment)}"`, c['userName']].join(',');
                csv += '\r\n';
            })
            const bom = '\uFEFF'; // Byte Order Mark
            var blob = new Blob([bom + csv], { type: "text/csv;charset=utf-8;" });
            var link = document.createElement("a");
            if (link.download !== undefined) {
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
        else {
            this.snackbarService.openSnackbar('No records found', ResponseMessageTypes.WARNING);
        }
    }
}